<template>
  <div class="empty-layout">
    <HeadBar :with-side-navigation="false" />
    <main class="empty-main">
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import HeadBar from '@/components/app/HeadBar.vue'
</script>

<style scoped lang="scss">
.empty-layout {
  min-height: var(--app-viewport-height);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.empty-main {
  flex: 1;
  padding: 2rem;
  background: #f8f9fa;
}
</style>
